import React from 'react';

import { useLanguage } from 'components/logic/LanguageProvider';
import {
  DISPLAYED_LANGUAGES,
  LANGUAGES,
  TLanguages,
} from 'components/logic/LanguageProvider/types/language-provider.interface';

import * as S from './LanguageSwitcher.styled';

export const LanguageSwitcher = (): React.ReactElement => {
  const { language, changeLanguage } = useLanguage();

  return (
    <S.LngSwitcher
      items={[
        { text: DISPLAYED_LANGUAGES.ENG, value: LANGUAGES.ENG },
        // { text: DISPLAYED_LANGUAGES.DEU, value: LANGUAGES.DEU },
        // { text: DISPLAYED_LANGUAGES.ITA, value: LANGUAGES.ITA },
        // { text: DISPLAYED_LANGUAGES.ESP, value: LANGUAGES.ESP },
        { text: DISPLAYED_LANGUAGES.RUS, value: LANGUAGES.RUS },
      ]}
      currentValue={language}
      onChange={(lang) => {
        changeLanguage(lang as TLanguages);
      }}
    />
  );
};
